var fridayContainer = document.querySelector(".for-grid-stacking");
var fridayReviews = document.querySelectorAll(".main-post-card");



//Set max height of the page for proper stacking
function setReviewsPageHeightfriday () {
  var reviewsHeightfriday = 0;
  var maxHeightfriday;
  if (fridayReviews) {
    for (var i = 0; i < fridayReviews.length; i++) {
      var review = fridayReviews[i];
      var reviewHeight = review.offsetHeight;
      reviewsHeightfriday = reviewsHeightfriday + reviewHeight;
    }
    if (window.innerWidth < 750) {
      maxHeightfriday = reviewsHeightfriday + 100;
    } else if (window.innerWidth < 990){
      maxHeightfriday = reviewsHeightfriday/2 + 100;
    } else {
      maxHeightfriday = reviewsHeightfriday/3 + 200;
    }
    fridayContainer.style.height = maxHeightfriday + 'px';
  }
}


window.addEventListener('DOMContentLoaded', function () { //OnLoad Events
  setReviewsPageHeightfriday();
  nextCity();
});

window.addEventListener('resize', function () { //Resize Events
  setReviewsPageHeightfriday();
});